<template>
  <v-row>
    <v-col cols="12"><h3>SETTING</h3></v-col>
    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12">
      <h4>CONTENT</h4>
    </v-col>
    <v-expansion-panels accordion class="list-section" style="max-height: 1100px !important">
      <draggable v-model="config.settings.blocks" @change="change" style="width: 100%">
        <transition-group>
          <v-expansion-panel v-for="(item, i) in config.settings.blocks" :key="`item${i}`">
            <v-expansion-panel-header expand-icon="mdi-menu-down" class="heading">
              <i class="fas fa-bars mr-2" style="flex: none !important"></i>
              {{ item.heading || 'Post' }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <label class="mt-2 d-inline-block" for="">Image</label>
              <UploadOneImage :itemSetData="item" :image="{ src: item.image }" @callback="getImage" />
              <label class="mt-5 d-inline-block" for="">Heading</label>
              <v-text-field
                hide-details
                height="auto"
                v-model="item.heading"
                @input="$parent.changeConfig"
              ></v-text-field>
              <label class="mt-4 d-inline-block" for="">Content</label>
              <v-textarea hide-details height="auto" v-model="item.content" @input="$parent.changeConfig"></v-textarea>
              <label class="mt-4 d-inline-block" for="">URL</label>
              <v-select
                hide-details
                v-model="item.url"
                :items="pageOptions"
                item-text="label"
                item-value="value"
                :loading="isLoading"
                @change="$parent.changeConfig"
              ></v-select>
              <div class="mt-4">
                <span
                  class="pointer font-weight-bold red--text"
                  @click="callbackRemoveContent(configSection.settings.blocks, i)"
                >
                  Remove
                </span>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </transition-group>
      </draggable>
    </v-expansion-panels>
    <v-col cols="12">
      <span
        class="pointer font-weight-bold primary--text"
        @click="callbackAddContent(configSection.settings.blocks, configSection.type)"
        >+ Add Post</span
      >
    </v-col>
    <v-col cols="12">
      <v-btn small outlined @click="callbackRemoveSection(configSection)">Remove Section</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import draggable from 'vuedraggable';
import storeRequest from '../../../../../apis/request/storeRequest';

export default {
  name: 'PostList',
  components: {
    draggable,
  },
  props: {
    callbackRemoveContent: {
      type: Function,
      default: () => {},
    },
    configSection: {
      type: Object,
      default: () => {},
    },
    callbackAddContent: {
      type: Function,
      default: () => {},
    },
    callbackRemoveSection: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      config: {},
      pages: [],
      isLoading: false,
    };
  },
  computed: {
    pageOptions() {
      return this.pages.map(page => ({
        label: page.title,
        value: `/blog/${page.handle}`,
      }));
    },
  },
  methods: {
    getImage(images, item) {
      item.image = images.src;
      this.$parent.changeConfig();
    },
    change() {
      this.$parent.changeConfig();
    },
    async getPages() {
      this.isLoading = true;
      try {
        const res = await storeRequest.get('/stores/onlinestore/pages', {
          params: { page: 1, limit: 1000 },
        });
        this.pages = res.data.pages;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
  },
  created() {
    this.config = this.configSection;
    this.getPages();
  },
};
</script>

<style lang="scss" scoped></style>
